import { injectGlobal, SimpleInterpolation } from "styled-components";

export const createGlobalStyle = (
  styles: TemplateStringsArray,
  ...interpolations: SimpleInterpolation[]
) => {
  return () => {
    injectGlobal(styles, ...interpolations);
    return null;
  };
};

/*
const Blue = createGlobalStyle`
  font-size: 20px;
`;

const NewComp = () => (
  <div>
    <Blue />
  </div>
)
*/
